export interface IFileUploadHeader {
    value: string;
    index: number;
}

export enum FileUploadHeaderType {
    LATITUDE,
    LONGITUDE,
    POLE_ID,
}

export enum FileUploadStep {
    UPLOAD_FILE,
    SELECT_FIELDS,
}

export interface IFileEntity {
    fileName: string;
    file: File;
}

export interface IFileUploadResponse {
    message: string;
    id: number;
    fieldList: Array<string>;
}

export interface IUploadedFile {
    id: number;
    pk: number;
    project_id: number;
    title: string;
    url: string;
    updated_at: string;
}

export interface ISequentialFileStorageObject {
    folderId: string;
    projectId: number;
    files: Array<File>;
}

export enum DownloadFilesSortField {
    TITLE,
    CREATED_DATE,
    AUTHOR,
}

export interface IQcFileResult {
    url: string;
    QC_inspection_name: string;
    QC_inspection_user_id: number;
    QC_inspection_timestamp: string;
    folder_fk: string;
    project_fk: number;
    total_entities: number;
    number_passed: number;
    number_rework: number;
    report_url: string;
    userName: string;
    QC_inspection_user_name: string;
}
